/* Enord Core classic v1.3 — Media + text (file: en-media-text-classic-v2.js): lazy-load videos, autoplay + loop in view, pause out of view, resume on return. v1.3: defends the element against site-wide scripts (PageFly/Tolstoy) that rewrite video src with #t=0.001 or pause it — any outside change to src is reverted and playback resumed. */
(function(){
  function clean(u){return (u||'').split('#')[0];}
  function play(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}
  function inView(v){var r=v.getBoundingClientRect();return r.bottom>-200&&r.top<innerHeight+200;}
  function load(v){
    if(v.dataset.emtDone)return;v.dataset.emtDone='1';
    v.muted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.removeAttribute('controls');
    var src=clean(v.getAttribute('data-src')||v.getAttribute('src'));
    if(!src)return;
    v.dataset.emtSrc=src;
    v.src=src;v.load();
    v.addEventListener('ended',function(){try{v.currentTime=0;}catch(e){}play(v);});
    v.addEventListener('pause',function(){if(!v.dataset.emtOurPause&&inView(v)&&document.visibilityState==='visible'){setTimeout(function(){if(v.paused&&inView(v))play(v);},50);}});
    if('MutationObserver' in window){
      new MutationObserver(function(ms){ms.forEach(function(m){
        if(m.attributeName==='src'){var cur=v.getAttribute('src')||'';if(cur!==v.dataset.emtSrc){v.src=v.dataset.emtSrc;v.load();if(inView(v))play(v);}}
        if(m.attributeName==='style'&&v.style.display==='none'){v.style.display='';}
      });}).observe(v,{attributes:true,attributeFilter:['src','style']});
    }
    play(v);
  }
  function init(){
    var vids=document.querySelectorAll('video[data-emt-video]');
    if(!('IntersectionObserver' in window)){vids.forEach(load);return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      var v=e.target;
      if(e.isIntersecting){if(!v.dataset.emtDone)load(v);else{delete v.dataset.emtOurPause;if(v.paused)play(v);}}
      else if(v.dataset.emtDone&&!v.paused){v.dataset.emtOurPause='1';v.pause();}
    });},{rootMargin:'200px 0px'});
    vids.forEach(function(v){io.observe(v);});
    document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')vids.forEach(function(v){if(v.dataset.emtDone&&v.paused&&inView(v)){delete v.dataset.emtOurPause;play(v);}});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
